import { UserIdRequestDTO } from './performed-by-request-dto';
import { RequestDTO } from './request-dto';

export interface ResendUserContextRoleRequestRequestDTO extends UserIdRequestDTO {
    userEmail?: string;
    requestKey?: string;
    languageCd?: string;
}

export interface SaveEmailValidationRequestDTO extends RequestDTO {
    requestKey?: string;
}
